<template>
  <div
    v-if="validationError"
    v-tooltip="{
      content: validationError,
      placement: 'top',
      distance: 10,
      delay: { show: 100, hide: 100 },
    }"
    class="validation absolute"
  >
    <SvgIcon icon="app-icons/code-warning" width="18" height="18" />
  </div>
</template>

<script setup>
import { getScripts } from '@/utils.js';
import { Interpreter, ParseError } from '@arcweave/arcscript';
import SvgIcon from '@ui/components/SvgIcon.vue';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const store = useStore();

const validationError = ref(null);
const variables = computed(
  () => store.getters['project/data/variables/getVariables']
);

/**
 * Parses the code blocks for validation and shows the error if any
 */
function validate() {
  validationError.value = null;
  if (!props.content) return;
  const fakeVisits = {};
  const elementIds = store.getters['project/data/elements/getNodeIds'];
  elementIds.forEach(id => {
    fakeVisits[id] = 0;
  });
  const randomElement = elementIds[0];
  const interpreter = new Interpreter(
    store.getters['playMode/getValues'],
    variables.value,
    fakeVisits,
    randomElement
  );
  validationError.value = null;

  if (props.content) {
    try {
      // During validation, we don't care of runScript() results
      interpreter.parse(props.content);
    } catch (error) {
      if (error instanceof ParseError) {
        validationError.value = error.message;
      } else {
        console.error(error);
      }
    }
  }
}

const scripts = computed(() => getScripts(props.content));

watch(scripts, validate, { immediate: true, deep: true });
watch(variables, validate, { immediate: true, deep: true });
</script>
